export const filterArticlesForColumn = <T>(
	articles: T[],
	column: number,
	screenSize: 'md' | 'lg'
): T[] => {
	return articles.filter((_, index) => {
		if (screenSize === 'md') {
			return index % 2 === column;
		}
		if (screenSize === 'lg') {
			return index % 3 === column;
		}

		return true;
	});
};
